import { render, staticRenderFns } from "./ApprovalResultDenied.vue?vue&type=template&id=42d32367&scoped=true"
import script from "./ApprovalResultDenied.vue?vue&type=script&lang=js"
export * from "./ApprovalResultDenied.vue?vue&type=script&lang=js"
import style0 from "./ApprovalResultDenied.vue?vue&type=style&index=0&id=42d32367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d32367",
  null
  
)

export default component.exports